<div class="content md3-surface grid-1-auto case-creator">
  <div class="content layout-auto-1">
    <!--Workflow Timeline-->
    <div class="md3-card-on-surface app-space-bottom wf-timeline">
      <div class="grid-auto-1-auto">
        <i (click)="clickedPrev()" [tooltip]="getRessource('Buttons.Back')" flow="right"
           style="font-size: medium"
           class="fal fa-arrow-left app-drawer-icon wf-navigate"
           [class.disabled]="createTaskConfig.disablePrevButton"></i>
        <div class="grid cols-3 wf-grid">
          <ng-container *ngFor="let step of createTaskConfig.timeline; index as i">
            <div class="stack-center">
              <i *ngIf="step.status === 2" class="fa-duotone fa-solid fa-circle-check wf-icon-full"></i>
              <div *ngIf="step.status !== 2" class="wf-navigation-point"
                   [ngClass]="{'in-progress': step.status === 1}"></div>
              <div *ngIf="i > 0" class="wf-line-connector"></div>
              <div *ngIf="i < createTaskConfig.timeline.length - 1" class="wf-line-progress"
                   [ngStyle]="{'width': step.status === 2 ? '100%' : '0%',
                              'background-color': step.status === 2 ? 'var(--c-green-400)' : 'var(--c-light-400)'}">
              </div>
              <span [ngStyle]="{'color': createTaskConfig.currentStepIndex === i ? 'var(--c-dark-400)' : 'var(--c-neutral-800)',
                        'font-weight': createTaskConfig.currentStepIndex === i ? '500' : '400' }">
                  {{step.caption}}
              </span>
            </div>
          </ng-container>
        </div>
        <i (click)="clickedNext()" [tooltip]="getRessource('Buttons.Next')" flow="left"
           style="font-size: medium"
           class="fal fa-arrow-right app-drawer-icon wf-navigate"
           [class.disabled]="createTaskConfig.disableNextButton"></i>
      </div>
    </div>

    <!--content & task list-->
    <div class="content grid-auto-1">
      <div class="md3-card-on-surface layout-auto-1 width-375">
        <h6 class="grid-1-auto">{{getRessource('Header.CreatedTasks')}}
          <ng-container *ngIf="newTaskStack.length > 0 && dl && dl.selectedRow !== -1">
            <i [tooltip]="getRessource('Tooltips.NewTask')" flow="left" (click)="startNewCreationCycle()" class="search-filter-action fas fa-plus"></i>
          </ng-container>
        </h6>
        <div>
          <exg-data-list #TaskList
                         [allowMultiSelection]="false"
                         [allowSingleSelection]="true"
                         [rowSource]="newTaskStack"
                         selectKey="vorgID"
                         [displayState]="newTaskListModel.state"
                         (RowChange)="newTaskListModel.selectItem($event)"
                         (RowDblClick)="newTaskListModel.doubleClick($event)" class="content">
            <ng-template #rowTemplate let-row >
              <div class="list-row list-two-line">
                <span class="list-primary-text">{{row.vorgNr}}</span>
                <span class="list-secondary-text">{{enumSvc.getEnumerationText(row.vorg_enmName_VorgangTyp,
                  row.vorg_enmIdent_VorgangTyp)}}</span>
              </div>
            </ng-template>
          </exg-data-list>
        </div>
      </div>

      <!-- main -->
      <div class="content md3-card-on-surface">

        <!-- Vorgangsanlage-->
        <div *ngIf="createTaskConfig.currentStepIndex === 0" class="content">
          <div class="content wf-content">
            <div class="wf-header">
              <h1>{{getRessource('Attachments.Title')}}</h1>
              <p>{{getRessource('CreateTask.Description')}}</p>
            </div>

            <div class="content">
              <!--Vorgangstyp -->
              <exg-select [(ngModel)]="selectedVorgangTypIndex"
                          [list]="vorgTypeEnumList"
                          listdisplay="enmText"
                          [caption]="enumSvc.getFieldCaption('Vorgang','vorg_enmIdent_VorgangTyp')"
                          name="vorgTyp"
                          disabled="{{createTaskConfig.createTaskInputsDisabled}}">
              </exg-select>

              <!--subtype select nur visible wenn es der Typ mit selector hergibt-->
              <exg-select *ngIf="selectedVorgangTypEnmSelector !== '' &&
                          vorgSubTypeEnumList.length > 0"
                          [(ngModel)]="selectedVorgangSubTypIndex"
                          [list]="vorgSubTypeEnumList"
                          listdisplay="enmText"
                          [caption]="enumSvc.getFieldCaption('Vorgang','vorgVorgangSubTyp_enmIdent')"
                          name="vorgSubTyp"
                          disabled="{{createTaskConfig.createTaskInputsDisabled}}">
              </exg-select>

              <!--Vorgangsbeschreibung-->
              <exg-textarea [(ngModel)]="selectedVorgBeschreibung" [caption]="enumSvc.getFieldCaption('Vorgang', 'vorgBeschreibung')"
                            type="text" name="vorgBeschreibung"
                            disabled="{{createTaskConfig.createTaskInputsDisabled}}">
              </exg-textarea>
              <div class="grid-1-auto app-space-top" style="gap: 1rem;">

                <button (click)="createTask()" class="md-btn"
                        [disabled]="createTaskConfig.createTaskButtonDisabled">
                  <i class="fal fa-plus-circle"></i>
                  {{getRessource('Buttons.CreateTask')}}
                </button>
                <button class="md-btn" (click)="clickedNext()"
                        [disabled]="createTaskConfig.disableNextButton">
                  {{getRessource('Buttons.Next')}} <i class="fal fa-arrow-right"></i>
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Anlagen auswahl -->
        <div *ngIf="createTaskConfig.currentStepIndex === 1"
             class="content layout-1"
             style="overflow: hidden; height: 100%;">
          <div class="content layout-1 wf-content"
               style="overflow: hidden; display: flex; flex-direction: column; height: 100%;">
            <div class="wf-header" style="flex-shrink: 0;">
              <h1>{{getRessource('Attachments.Title')}}</h1>
              <p>{{getRessource('Attachments.Description')}}</p>
            </div>

            <div class="content"
                 style="display: flex; flex-direction: column; flex: 1; overflow: hidden;">
              <!-- anlagen übersicht -->
              <div class="content"
                   style="flex: 1; overflow-y: auto; overflow-x: hidden; min-height: 0;">
                <ng-container *ngIf="caseSummary?.attachmentJagTable?.jagdata && !caseSummary?.attachmentJagTable?.isLoading">
                  <ng-container *ngFor="let folder of caseSummary?.attachmentJagTable?.jagdata">
                    <ng-container *ngIf="folder.source === 'document'">
                      <div class="grid-1-auto app-space_075">
                        <div *ngIf="folder.source === 'document'">
                          {{enumSvc.getEnumerationText('DokTyp', folder.dok_enmIdent_DokTyp)}}
                        </div>
<!--                      <div *ngIf="folder.source === 'report'">-->
<!--                        {{getRessource('reportFolder')}}-->
<!--                      </div>-->
<!--                      <div *ngIf="folder.source === 'Fragebogen'">-->
<!--                        {{getRessource('questFolder')}}-->
<!--                      </div>-->
                        <div>({{folder.dokFolderCount}})</div>
                      </div>
                      <div class="flex-container app-space_025">
                        <div class="flex-row">
                          <ng-container *ngFor="let docElement of folder.documents">
                            <div class="grid-auto-1">
                              <div class="app-checkbox-multiSelection">
                                <exg-checkbox *ngIf="folder.dok_enmIdent_DokTyp !== -1"
                                              [id]="docElement.dokID + 'selection'"
                                              [ngModel]="selectedAttachments[docElement.dokID]"
                                              (ngModelChange)="onAttachmentSelection(docElement.dokID, $event)"
                                              [class.disabled]="isAttachmentAlreadyCopied(docElement.dokID)"
                                              [style.pointer-events]="isAttachmentAlreadyCopied(docElement.dokID) ? 'none' : 'auto'"
                                              [style.opacity]="isAttachmentAlreadyCopied(docElement.dokID) ? '0.5' : '1'">
                                </exg-checkbox>
                              </div>
                              <div class="md3-card-on-surface app-space width-400"
                                   style="padding: 4px 8px; margin: 4px 4px;">
                                <div class="grid-auto-1">
                                  <ng-container *ngIf="docElement.dokMode !== 'Bericht' && docElement.dokMode !== 'Fragebogen'">
                                    <div style="cursor: pointer" class="list-avatar-placeholder">
                                      <img src="{{excRest.computeUrl('ImageThumbnail',{dokID: docElement.dokID})}}"
                                           alt="" class="list-avatar-placeholder"/>
                                    </div>
                                  </ng-container>
                                  <ng-container *ngIf="docElement.dokMode === 'Bericht'">
                                    <div class="typo-center app-space-right_075">
                                      <i class="fa-2xl fa-duotone fa-file-check"></i>
                                    </div>
                                  </ng-container>
                                  <ng-container *ngIf="docElement.dokMode === 'Fragebogen'">
                                    <div class="typo-center app-space-right_075">
                                      <i class="fa-2xl fa-duotone fa-clipboard-list"></i>
                                    </div>
                                  </ng-container>
                                  <div class="layout-auto-1-auto-grid-1-auto grid typo-small">
                                    <div class="list-metadata" style="margin-left:0">
                                      <div>
                                        <ng-container *ngIf="docElement.linked">
                                  <span flow="left" style="font-size: medium"
                                        [tooltip]="getRessource('tooltip.linked')">
                                    <i class="fal fa-link"></i>
                                    <ng-container *ngIf="!docElement.dokTrackingPortalShare">
                                      &nbsp;-&nbsp;
                                    </ng-container>
                                  </span>
                                        </ng-container>
                                        <ng-container *ngIf="docElement.dokTrackingPortalShare">
                                  <span flow="left" style="font-size: medium"
                                        [tooltip]="getRessource('tooltip.trackingPortal')">
                                    <i class="fal fa-cloud"></i> -
                                  </span>
                                        </ng-container>
                                        {{docElement.dok_enmIdent_DokTyp >= 0 && docElement.dokGroesse > 0 ? appSvc.file.calcFileSize(docElement.dokGroesse, false) + ' - ' : ''}}
                                        {{docElement.dokMode}}
                                      </div>
                                    </div>
                                    <div class="grid-1-auto">
                                      <div class="list-metadata">
                                        <div class="typo-right">
                                          {{docElement.dokLCD | excDate: 'Globals.DateTimeFormatShort'}}
                                        </div>
                                        <div class="typo-right">{{docElement.dokCRU}}</div>
                                      </div>
                                    </div>
                                    <div class="span-2">
                                      <div class="grid-1-auto">
                                        <div style="overflow: hidden">
                                          <strong>{{docElement.dokName}}{{docElement.dokErw}}</strong>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="span-2 list-secondary-text">{{docElement.dokBeschreibung}}</div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </ng-container>
                  </ng-container>
                </ng-container>

                <div class="splash loading" *ngIf="caseSummary?.attachmentJagTable?.isLoading">
                  <div class="spinner">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                  </div>
                </div>

                <div class="splash empty" *ngIf="caseSummary?.attachmentJagTable?.isEmpty && !caseSummary?.attachmentJagTable?.isLoading">
                  <p>{{getRessource('Attachments.Ghost')}}</p>
                </div>
              </div>

              <div class="grid-1-auto app-space-top"
                   style="gap: 1rem; flex-shrink: 0; padding: 1rem 0;">
                <button (click)="completeCurrentStep(2)" class="md-btn"
                        [disabled]="selectedAttachmentsCount === 0 || !dl || dl.selectedRow === -1">
                  <i class="fal fa-paperclip"></i>
                  {{selectedAttachmentsCount + ' Anlagen kopieren'}}
                </button>

                <button class="md-btn" (click)="clickedNext()"
                        [disabled]="createTaskConfig.disableNextButton">
                  {{getRessource('Buttons.Next')}} <i class="fal fa-arrow-right"></i>
                </button>
              </div>
            </div>
          </div>
        </div>

        <!--Abschluss-->
        <div *ngIf="createTaskConfig.currentStepIndex === 2" class="content">
          <div class="content wf-content">
            <div class="wf-header">
              <h1>{{getRessource('Finish.Title')}}</h1>
              <p>{{getRessource('Finish.Description')}}</p>

              <div class="app-space-top" *ngIf="newTaskStack.length > 0">
                <div class="md3-card-on-surface" style="padding: 1rem;">
                  <h6>{{getRessource('Finish.CreatedTasks')}} ({{newTaskStack.length}}):</h6>
                  <div *ngFor="let task of newTaskStack; let i = index"
                       class="app-space-bottom"
                       style="padding: 0.5rem; border-left: 3px solid var(--c-primary-400); margin-bottom: 1rem;">

                    <p><strong>{{task.vorgNr}}</strong> - {{enumSvc.getEnumerationText(task.vorg_enmName_VorgangTyp, task.vorg_enmIdent_VorgangTyp)}}</p>
                    <p style="margin: 0.25rem 0;"><em>{{task.vorgBeschreibung}}</em></p>

                    <p style="margin: 0; font-size: 0.9rem;" *ngIf="getAttachmentCount(task) > 0">
                      <i class="fal fa-paperclip"></i>
                      {{getAttachmentCount(task)}} Anlagen kopiert
                    </p>
                  </div>
                </div>
              </div>
              <!-- Todo übersicht anhänge im abschluss-->

              <div style="text-align: center; margin-top: 2rem;">
                <button (click)="appSvc.Task.Workspace.OpenTabV2(newTaskStack[dl.selectedRow].vorgID)"
                        class="md-btn"
                        *ngIf="dl &&
                        dl.selectedRow >= 0 &&
                        dl.selectedRow < newTaskStack.length &&
                        excSecurity.isFeatured('TASKREAD')">
                  <i class="fal fa-external-link"></i>
                  {{getRessource('Attachments.OpenSelected')}}
                </button>
                <button (click)="startNewCreationCycle()"
                        class="md-btn"
                        *ngIf="newTaskStack.length > 0">
                  <i class="fal fa-plus"></i>
                  {{getRessource('Attachments.CreateNew')}}
                </button>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</div>
